// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "users/v1/service.proto" (package "users.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../google/protobuf/field_mask.js";
import { PaginationResponse } from "../../common/v1/common.js";
import { PaginationRequest } from "../../common/v1/common.js";
/**
 * Enums
 *
 * @generated from protobuf enum users.v1.TenantStatus
 */
export var TenantStatus;
(function (TenantStatus) {
    /**
     * @generated from protobuf enum value: TENANT_STATUS_UNSPECIFIED = 0;
     */
    TenantStatus[TenantStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: TENANT_STATUS_ACTIVE = 1;
     */
    TenantStatus[TenantStatus["ACTIVE"] = 1] = "ACTIVE";
    /**
     * @generated from protobuf enum value: TENANT_STATUS_INACTIVE = 2;
     */
    TenantStatus[TenantStatus["INACTIVE"] = 2] = "INACTIVE";
    /**
     * @generated from protobuf enum value: TENANT_STATUS_SUSPENDED = 3;
     */
    TenantStatus[TenantStatus["SUSPENDED"] = 3] = "SUSPENDED";
})(TenantStatus || (TenantStatus = {}));
/**
 * @generated from protobuf enum users.v1.IdpType
 */
export var IdpType;
(function (IdpType) {
    /**
     * @generated from protobuf enum value: IDP_TYPE_UNSPECIFIED = 0;
     */
    IdpType[IdpType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: IDP_TYPE_COGNITO = 1;
     */
    IdpType[IdpType["COGNITO"] = 1] = "COGNITO";
    /**
     * @generated from protobuf enum value: IDP_TYPE_OIDC = 2;
     */
    IdpType[IdpType["OIDC"] = 2] = "OIDC";
    /**
     * @generated from protobuf enum value: IDP_TYPE_SAML = 3;
     */
    IdpType[IdpType["SAML"] = 3] = "SAML";
})(IdpType || (IdpType = {}));
/**
 * @generated from protobuf enum users.v1.UserTenantStatus
 */
export var UserTenantStatus;
(function (UserTenantStatus) {
    /**
     * @generated from protobuf enum value: USER_TENANT_STATUS_UNSPECIFIED = 0;
     */
    UserTenantStatus[UserTenantStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: USER_TENANT_STATUS_ACTIVE = 1;
     */
    UserTenantStatus[UserTenantStatus["ACTIVE"] = 1] = "ACTIVE";
    /**
     * @generated from protobuf enum value: USER_TENANT_STATUS_INACTIVE = 2;
     */
    UserTenantStatus[UserTenantStatus["INACTIVE"] = 2] = "INACTIVE";
    /**
     * @generated from protobuf enum value: USER_TENANT_STATUS_SUSPENDED = 3;
     */
    UserTenantStatus[UserTenantStatus["SUSPENDED"] = 3] = "SUSPENDED";
})(UserTenantStatus || (UserTenantStatus = {}));
/**
 * Per-(user, customer) membership group. Customer-scoped, hierarchical.
 * Rank order (highest first): ops_admin > customer_admin > bidding_admin > customer_member.
 * global_admin is a separate boolean on the User and is NOT a customer_group.
 *
 * @generated from protobuf enum users.v1.CustomerGroup
 */
export var CustomerGroup;
(function (CustomerGroup) {
    /**
     * @generated from protobuf enum value: CUSTOMER_GROUP_UNSPECIFIED = 0;
     */
    CustomerGroup[CustomerGroup["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: CUSTOMER_GROUP_OPS_ADMIN = 1;
     */
    CustomerGroup[CustomerGroup["OPS_ADMIN"] = 1] = "OPS_ADMIN";
    /**
     * @generated from protobuf enum value: CUSTOMER_GROUP_CUSTOMER_ADMIN = 2;
     */
    CustomerGroup[CustomerGroup["CUSTOMER_ADMIN"] = 2] = "CUSTOMER_ADMIN";
    /**
     * @generated from protobuf enum value: CUSTOMER_GROUP_BIDDING_ADMIN = 3;
     */
    CustomerGroup[CustomerGroup["BIDDING_ADMIN"] = 3] = "BIDDING_ADMIN";
    /**
     * @generated from protobuf enum value: CUSTOMER_GROUP_CUSTOMER_MEMBER = 4;
     */
    CustomerGroup[CustomerGroup["CUSTOMER_MEMBER"] = 4] = "CUSTOMER_MEMBER";
})(CustomerGroup || (CustomerGroup = {}));
/**
 * Platform-wide role tier (separate axis from CustomerGroup). Gates the
 * cross-tenant admin backend. UNSPECIFIED = not a platform/admin user.
 * global_admin is the most privileged; global_ops is a restricted ops tier;
 * trader is an admin-only bidding + energy-reports role (orthogonal to ops).
 * Invariant: is_global_admin == (platform_role == PLATFORM_ROLE_GLOBAL_ADMIN).
 *
 * @generated from protobuf enum users.v1.PlatformRole
 */
export var PlatformRole;
(function (PlatformRole) {
    /**
     * @generated from protobuf enum value: PLATFORM_ROLE_UNSPECIFIED = 0;
     */
    PlatformRole[PlatformRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PLATFORM_ROLE_GLOBAL_ADMIN = 1;
     */
    PlatformRole[PlatformRole["GLOBAL_ADMIN"] = 1] = "GLOBAL_ADMIN";
    /**
     * @generated from protobuf enum value: PLATFORM_ROLE_GLOBAL_OPS = 2;
     */
    PlatformRole[PlatformRole["GLOBAL_OPS"] = 2] = "GLOBAL_OPS";
    /**
     * @generated from protobuf enum value: PLATFORM_ROLE_TRADER = 3;
     */
    PlatformRole[PlatformRole["TRADER"] = 3] = "TRADER";
})(PlatformRole || (PlatformRole = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Tenant$Type extends MessageType {
    constructor() {
        super("users.v1.Tenant", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["users.v1.TenantStatus", TenantStatus, "TENANT_STATUS_"] },
            { no: 5, name: "authz_version", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.slug = "";
        message.status = 0;
        message.authzVersion = 0n;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string slug */ 3:
                    message.slug = reader.string();
                    break;
                case /* users.v1.TenantStatus status */ 4:
                    message.status = reader.int32();
                    break;
                case /* uint64 authz_version */ 5:
                    message.authzVersion = reader.uint64().toBigInt();
                    break;
                case /* uint64 created_at */ 6:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 7:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string slug = 3; */
        if (message.slug !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.slug);
        /* users.v1.TenantStatus status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* uint64 authz_version = 5; */
        if (message.authzVersion !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.authzVersion);
        /* uint64 created_at = 6; */
        if (message.createdAt !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 7; */
        if (message.updatedAt !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.updatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.Tenant
 */
export const Tenant = new Tenant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenantIdentityProvider$Type extends MessageType {
    constructor() {
        super("users.v1.TenantIdentityProvider", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["users.v1.IdpType", IdpType, "IDP_TYPE_"] },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "issuer_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "client_secret_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "saml_metadata_xml", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cognito_user_pool_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "mapping_rules", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 13, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.tenantId = "";
        message.type = 0;
        message.displayName = "";
        message.issuerUrl = "";
        message.clientId = "";
        message.clientSecretHash = "";
        message.samlMetadataXml = "";
        message.cognitoUserPoolId = "";
        message.mappingRules = "";
        message.enabled = false;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* users.v1.IdpType type */ 3:
                    message.type = reader.int32();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* string issuer_url */ 5:
                    message.issuerUrl = reader.string();
                    break;
                case /* string client_id */ 6:
                    message.clientId = reader.string();
                    break;
                case /* string client_secret_hash */ 7:
                    message.clientSecretHash = reader.string();
                    break;
                case /* string saml_metadata_xml */ 8:
                    message.samlMetadataXml = reader.string();
                    break;
                case /* string cognito_user_pool_id */ 9:
                    message.cognitoUserPoolId = reader.string();
                    break;
                case /* string mapping_rules */ 10:
                    message.mappingRules = reader.string();
                    break;
                case /* bool enabled */ 11:
                    message.enabled = reader.bool();
                    break;
                case /* uint64 created_at */ 12:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 13:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* users.v1.IdpType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* string issuer_url = 5; */
        if (message.issuerUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.issuerUrl);
        /* string client_id = 6; */
        if (message.clientId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.clientId);
        /* string client_secret_hash = 7; */
        if (message.clientSecretHash !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.clientSecretHash);
        /* string saml_metadata_xml = 8; */
        if (message.samlMetadataXml !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.samlMetadataXml);
        /* string cognito_user_pool_id = 9; */
        if (message.cognitoUserPoolId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.cognitoUserPoolId);
        /* string mapping_rules = 10; */
        if (message.mappingRules !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.mappingRules);
        /* bool enabled = 11; */
        if (message.enabled !== false)
            writer.tag(11, WireType.Varint).bool(message.enabled);
        /* uint64 created_at = 12; */
        if (message.createdAt !== 0n)
            writer.tag(12, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 13; */
        if (message.updatedAt !== 0n)
            writer.tag(13, WireType.Varint).uint64(message.updatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.TenantIdentityProvider
 */
export const TenantIdentityProvider = new TenantIdentityProvider$Type();
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType {
    constructor() {
        super("users.v1.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "picture_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_global_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "user_tenants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserTenant },
            { no: 10, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 17, name: "platform_role", kind: "enum", T: () => ["users.v1.PlatformRole", PlatformRole, "PLATFORM_ROLE_"] },
            { no: 18, name: "cognito_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.email = "";
        message.givenName = "";
        message.familyName = "";
        message.pictureUrl = "";
        message.isGlobalAdmin = false;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.userTenants = [];
        message.name = "";
        message.deletedAt = 0n;
        message.platformRole = 0;
        message.cognitoDisabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string given_name */ 3:
                    message.givenName = reader.string();
                    break;
                case /* string family_name */ 4:
                    message.familyName = reader.string();
                    break;
                case /* string picture_url */ 5:
                    message.pictureUrl = reader.string();
                    break;
                case /* bool is_global_admin */ 6:
                    message.isGlobalAdmin = reader.bool();
                    break;
                case /* uint64 created_at */ 7:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 8:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* repeated users.v1.UserTenant user_tenants */ 9:
                    message.userTenants.push(UserTenant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string name */ 10:
                    message.name = reader.string();
                    break;
                case /* uint64 deleted_at */ 16:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* users.v1.PlatformRole platform_role */ 17:
                    message.platformRole = reader.int32();
                    break;
                case /* bool cognito_disabled */ 18:
                    message.cognitoDisabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string given_name = 3; */
        if (message.givenName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.givenName);
        /* string family_name = 4; */
        if (message.familyName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.familyName);
        /* string picture_url = 5; */
        if (message.pictureUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pictureUrl);
        /* bool is_global_admin = 6; */
        if (message.isGlobalAdmin !== false)
            writer.tag(6, WireType.Varint).bool(message.isGlobalAdmin);
        /* uint64 created_at = 7; */
        if (message.createdAt !== 0n)
            writer.tag(7, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 8; */
        if (message.updatedAt !== 0n)
            writer.tag(8, WireType.Varint).uint64(message.updatedAt);
        /* repeated users.v1.UserTenant user_tenants = 9; */
        for (let i = 0; i < message.userTenants.length; i++)
            UserTenant.internalBinaryWrite(message.userTenants[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string name = 10; */
        if (message.name !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.name);
        /* uint64 deleted_at = 16; */
        if (message.deletedAt !== 0n)
            writer.tag(16, WireType.Varint).uint64(message.deletedAt);
        /* users.v1.PlatformRole platform_role = 17; */
        if (message.platformRole !== 0)
            writer.tag(17, WireType.Varint).int32(message.platformRole);
        /* bool cognito_disabled = 18; */
        if (message.cognitoDisabled !== false)
            writer.tag(18, WireType.Varint).bool(message.cognitoDisabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.User
 */
export const User = new User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserTenant$Type extends MessageType {
    constructor() {
        super("users.v1.UserTenant", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["users.v1.UserTenantStatus", UserTenantStatus, "USER_TENANT_STATUS_"] },
            { no: 4, name: "primary_tenant", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "user", kind: "message", T: () => User },
            { no: 8, name: "tenant", kind: "message", T: () => Tenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.tenantId = "";
        message.status = 0;
        message.primaryTenant = false;
        message.createdAt = 0n;
        message.updatedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* users.v1.UserTenantStatus status */ 3:
                    message.status = reader.int32();
                    break;
                case /* bool primary_tenant */ 4:
                    message.primaryTenant = reader.bool();
                    break;
                case /* uint64 created_at */ 5:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 6:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* users.v1.User user */ 7:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* users.v1.Tenant tenant */ 8:
                    message.tenant = Tenant.internalBinaryRead(reader, reader.uint32(), options, message.tenant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* users.v1.UserTenantStatus status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        /* bool primary_tenant = 4; */
        if (message.primaryTenant !== false)
            writer.tag(4, WireType.Varint).bool(message.primaryTenant);
        /* uint64 created_at = 5; */
        if (message.createdAt !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 6; */
        if (message.updatedAt !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.updatedAt);
        /* users.v1.User user = 7; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* users.v1.Tenant tenant = 8; */
        if (message.tenant)
            Tenant.internalBinaryWrite(message.tenant, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UserTenant
 */
export const UserTenant = new UserTenant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Identity$Type extends MessageType {
    constructor() {
        super("users.v1.Identity", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "idp_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "raw_claims", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.idpId = "";
        message.subject = "";
        message.rawClaims = "";
        message.createdAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* string idp_id */ 3:
                    message.idpId = reader.string();
                    break;
                case /* string subject */ 4:
                    message.subject = reader.string();
                    break;
                case /* string raw_claims */ 5:
                    message.rawClaims = reader.string();
                    break;
                case /* uint64 created_at */ 6:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string idp_id = 3; */
        if (message.idpId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.idpId);
        /* string subject = 4; */
        if (message.subject !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.subject);
        /* string raw_claims = 5; */
        if (message.rawClaims !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.rawClaims);
        /* uint64 created_at = 6; */
        if (message.createdAt !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.Identity
 */
export const Identity = new Identity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Customer$Type extends MessageType {
    constructor() {
        super("users.v1.Customer", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "parent_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "activation_date", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 11, name: "tariff_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "fleet_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.tenantId = "";
        message.name = "";
        message.externalRef = "";
        message.parentCustomerId = "";
        message.address = "";
        message.phone = "";
        message.createdAt = 0n;
        message.deletedAt = 0n;
        message.activationDate = 0n;
        message.tariffId = "";
        message.siteId = "";
        message.fleetId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string external_ref */ 4:
                    message.externalRef = reader.string();
                    break;
                case /* string parent_customer_id */ 5:
                    message.parentCustomerId = reader.string();
                    break;
                case /* string address */ 6:
                    message.address = reader.string();
                    break;
                case /* string phone */ 7:
                    message.phone = reader.string();
                    break;
                case /* uint64 created_at */ 8:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 9:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 activation_date */ 10:
                    message.activationDate = reader.uint64().toBigInt();
                    break;
                case /* string tariff_id */ 11:
                    message.tariffId = reader.string();
                    break;
                case /* string site_id */ 12:
                    message.siteId = reader.string();
                    break;
                case /* string fleet_id */ 13:
                    message.fleetId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string external_ref = 4; */
        if (message.externalRef !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalRef);
        /* string parent_customer_id = 5; */
        if (message.parentCustomerId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentCustomerId);
        /* string address = 6; */
        if (message.address !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.address);
        /* string phone = 7; */
        if (message.phone !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.phone);
        /* uint64 created_at = 8; */
        if (message.createdAt !== 0n)
            writer.tag(8, WireType.Varint).uint64(message.createdAt);
        /* uint64 deleted_at = 9; */
        if (message.deletedAt !== 0n)
            writer.tag(9, WireType.Varint).uint64(message.deletedAt);
        /* uint64 activation_date = 10; */
        if (message.activationDate !== 0n)
            writer.tag(10, WireType.Varint).uint64(message.activationDate);
        /* string tariff_id = 11; */
        if (message.tariffId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.tariffId);
        /* string site_id = 12; */
        if (message.siteId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.siteId);
        /* string fleet_id = 13; */
        if (message.fleetId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.fleetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.Customer
 */
export const Customer = new Customer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessibleCustomer$Type extends MessageType {
    constructor() {
        super("users.v1.AccessibleCustomer", [
            { no: 1, name: "customer", kind: "message", T: () => Customer },
            { no: 2, name: "group", kind: "enum", T: () => ["users.v1.CustomerGroup", CustomerGroup, "CUSTOMER_GROUP_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.group = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* users.v1.CustomerGroup group */ 2:
                    message.group = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* users.v1.CustomerGroup group = 2; */
        if (message.group !== 0)
            writer.tag(2, WireType.Varint).int32(message.group);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.AccessibleCustomer
 */
export const AccessibleCustomer = new AccessibleCustomer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserCustomer$Type extends MessageType {
    constructor() {
        super("users.v1.UserCustomer", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group", kind: "enum", T: () => ["users.v1.CustomerGroup", CustomerGroup, "CUSTOMER_GROUP_"] },
            { no: 4, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "created_by_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user", kind: "message", T: () => User },
            { no: 7, name: "customer", kind: "message", T: () => Customer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.customerId = "";
        message.group = 0;
        message.createdAt = 0n;
        message.createdByUserId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                case /* users.v1.CustomerGroup group */ 3:
                    message.group = reader.int32();
                    break;
                case /* uint64 created_at */ 4:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* string created_by_user_id */ 5:
                    message.createdByUserId = reader.string();
                    break;
                case /* users.v1.User user */ 6:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* users.v1.Customer customer */ 7:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        /* users.v1.CustomerGroup group = 3; */
        if (message.group !== 0)
            writer.tag(3, WireType.Varint).int32(message.group);
        /* uint64 created_at = 4; */
        if (message.createdAt !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.createdAt);
        /* string created_by_user_id = 5; */
        if (message.createdByUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdByUserId);
        /* users.v1.User user = 6; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* users.v1.Customer customer = 7; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UserCustomer
 */
export const UserCustomer = new UserCustomer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTenantsRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ListTenantsRequest", [
            { no: 1, name: "status", kind: "enum", T: () => ["users.v1.TenantStatus", TenantStatus, "TENANT_STATUS_"] },
            { no: 2, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = 0;
        message.slug = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.TenantStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* string slug */ 2:
                    message.slug = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.TenantStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* string slug = 2; */
        if (message.slug !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.slug);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListTenantsRequest
 */
export const ListTenantsRequest = new ListTenantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListTenantsResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ListTenantsResponse", [
            { no: 1, name: "tenants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Tenant },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tenants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.Tenant tenants */ 1:
                    message.tenants.push(Tenant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.Tenant tenants = 1; */
        for (let i = 0; i < message.tenants.length; i++)
            Tenant.internalBinaryWrite(message.tenants[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListTenantsResponse
 */
export const ListTenantsResponse = new ListTenantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.CreateTenantRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["users.v1.TenantStatus", TenantStatus, "TENANT_STATUS_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.slug = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string slug */ 2:
                    message.slug = reader.string();
                    break;
                case /* users.v1.TenantStatus status */ 3:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string slug = 2; */
        if (message.slug !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.slug);
        /* users.v1.TenantStatus status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateTenantRequest
 */
export const CreateTenantRequest = new CreateTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.CreateTenantResponse", [
            { no: 1, name: "tenant", kind: "message", T: () => Tenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Tenant tenant */ 1:
                    message.tenant = Tenant.internalBinaryRead(reader, reader.uint32(), options, message.tenant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Tenant tenant = 1; */
        if (message.tenant)
            Tenant.internalBinaryWrite(message.tenant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateTenantResponse
 */
export const CreateTenantResponse = new CreateTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetTenantRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetTenantRequest
 */
export const GetTenantRequest = new GetTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetTenantResponse", [
            { no: 1, name: "tenant", kind: "message", T: () => Tenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Tenant tenant */ 1:
                    message.tenant = Tenant.internalBinaryRead(reader, reader.uint32(), options, message.tenant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Tenant tenant = 1; */
        if (message.tenant)
            Tenant.internalBinaryWrite(message.tenant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetTenantResponse
 */
export const GetTenantResponse = new GetTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateTenantRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["users.v1.TenantStatus", TenantStatus, "TENANT_STATUS_"] },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.slug = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string slug */ 3:
                    message.slug = reader.string();
                    break;
                case /* users.v1.TenantStatus status */ 4:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 5:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string slug = 3; */
        if (message.slug !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.slug);
        /* users.v1.TenantStatus status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* google.protobuf.FieldMask update_mask = 5; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateTenantRequest
 */
export const UpdateTenantRequest = new UpdateTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateTenantResponse", [
            { no: 1, name: "tenant", kind: "message", T: () => Tenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Tenant tenant */ 1:
                    message.tenant = Tenant.internalBinaryRead(reader, reader.uint32(), options, message.tenant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Tenant tenant = 1; */
        if (message.tenant)
            Tenant.internalBinaryWrite(message.tenant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateTenantResponse
 */
export const UpdateTenantResponse = new UpdateTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteTenantRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteTenantRequest
 */
export const DeleteTenantRequest = new DeleteTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteTenantResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteTenantResponse
 */
export const DeleteTenantResponse = new DeleteTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BumpAuthzVersionRequest$Type extends MessageType {
    constructor() {
        super("users.v1.BumpAuthzVersionRequest", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.BumpAuthzVersionRequest
 */
export const BumpAuthzVersionRequest = new BumpAuthzVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BumpAuthzVersionResponse$Type extends MessageType {
    constructor() {
        super("users.v1.BumpAuthzVersionResponse", [
            { no: 1, name: "new_version", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.newVersion = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 new_version */ 1:
                    message.newVersion = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 new_version = 1; */
        if (message.newVersion !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.newVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.BumpAuthzVersionResponse
 */
export const BumpAuthzVersionResponse = new BumpAuthzVersionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsersRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ListUsersRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_global_admin", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 5, name: "include_deactivated", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* optional bool is_global_admin */ 2:
                    message.isGlobalAdmin = reader.bool();
                    break;
                case /* string tenant_id */ 3:
                    message.tenantId = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 4:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* optional bool include_deactivated */ 5:
                    message.includeDeactivated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* optional bool is_global_admin = 2; */
        if (message.isGlobalAdmin !== undefined)
            writer.tag(2, WireType.Varint).bool(message.isGlobalAdmin);
        /* string tenant_id = 3; */
        if (message.tenantId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenantId);
        /* common.v1.PaginationRequest pagination = 4; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional bool include_deactivated = 5; */
        if (message.includeDeactivated !== undefined)
            writer.tag(5, WireType.Varint).bool(message.includeDeactivated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListUsersRequest
 */
export const ListUsersRequest = new ListUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsersResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ListUsersResponse", [
            { no: 1, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.users = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.User users */ 1:
                    message.users.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.User users = 1; */
        for (let i = 0; i < message.users.length; i++)
            User.internalBinaryWrite(message.users[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListUsersResponse
 */
export const ListUsersResponse = new ListUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserRequest$Type extends MessageType {
    constructor() {
        super("users.v1.CreateUserRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "picture_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_global_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "platform_role", kind: "enum", opt: true, T: () => ["users.v1.PlatformRole", PlatformRole, "PLATFORM_ROLE_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.givenName = "";
        message.familyName = "";
        message.pictureUrl = "";
        message.isGlobalAdmin = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string given_name */ 2:
                    message.givenName = reader.string();
                    break;
                case /* string family_name */ 3:
                    message.familyName = reader.string();
                    break;
                case /* string picture_url */ 4:
                    message.pictureUrl = reader.string();
                    break;
                case /* bool is_global_admin */ 5:
                    message.isGlobalAdmin = reader.bool();
                    break;
                case /* optional users.v1.PlatformRole platform_role */ 6:
                    message.platformRole = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string given_name = 2; */
        if (message.givenName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.givenName);
        /* string family_name = 3; */
        if (message.familyName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.familyName);
        /* string picture_url = 4; */
        if (message.pictureUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pictureUrl);
        /* bool is_global_admin = 5; */
        if (message.isGlobalAdmin !== false)
            writer.tag(5, WireType.Varint).bool(message.isGlobalAdmin);
        /* optional users.v1.PlatformRole platform_role = 6; */
        if (message.platformRole !== undefined)
            writer.tag(6, WireType.Varint).int32(message.platformRole);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateUserRequest
 */
export const CreateUserRequest = new CreateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserResponse$Type extends MessageType {
    constructor() {
        super("users.v1.CreateUserResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateUserResponse
 */
export const CreateUserResponse = new CreateUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetUserRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_tenants", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.includeTenants = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool include_tenants */ 2:
                    message.includeTenants = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool include_tenants = 2; */
        if (message.includeTenants !== false)
            writer.tag(2, WireType.Varint).bool(message.includeTenants);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetUserRequest
 */
export const GetUserRequest = new GetUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetUserResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetUserResponse
 */
export const GetUserResponse = new GetUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserByEmailRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetUserByEmailRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_tenants", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.includeTenants = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* bool include_tenants */ 2:
                    message.includeTenants = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* bool include_tenants = 2; */
        if (message.includeTenants !== false)
            writer.tag(2, WireType.Varint).bool(message.includeTenants);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetUserByEmailRequest
 */
export const GetUserByEmailRequest = new GetUserByEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserByEmailResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetUserByEmailResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetUserByEmailResponse
 */
export const GetUserByEmailResponse = new GetUserByEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserRequest$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateUserRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "given_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "family_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "picture_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_global_admin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 8, name: "platform_role", kind: "enum", opt: true, T: () => ["users.v1.PlatformRole", PlatformRole, "PLATFORM_ROLE_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.email = "";
        message.givenName = "";
        message.familyName = "";
        message.pictureUrl = "";
        message.isGlobalAdmin = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string given_name */ 3:
                    message.givenName = reader.string();
                    break;
                case /* string family_name */ 4:
                    message.familyName = reader.string();
                    break;
                case /* string picture_url */ 5:
                    message.pictureUrl = reader.string();
                    break;
                case /* bool is_global_admin */ 6:
                    message.isGlobalAdmin = reader.bool();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 7:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* optional users.v1.PlatformRole platform_role */ 8:
                    message.platformRole = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string given_name = 3; */
        if (message.givenName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.givenName);
        /* string family_name = 4; */
        if (message.familyName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.familyName);
        /* string picture_url = 5; */
        if (message.pictureUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pictureUrl);
        /* bool is_global_admin = 6; */
        if (message.isGlobalAdmin !== false)
            writer.tag(6, WireType.Varint).bool(message.isGlobalAdmin);
        /* google.protobuf.FieldMask update_mask = 7; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional users.v1.PlatformRole platform_role = 8; */
        if (message.platformRole !== undefined)
            writer.tag(8, WireType.Varint).int32(message.platformRole);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateUserRequest
 */
export const UpdateUserRequest = new UpdateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserResponse$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateUserResponse", [
            { no: 1, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateUserResponse
 */
export const UpdateUserResponse = new UpdateUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserRequest$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteUserRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteUserRequest
 */
export const DeleteUserRequest = new DeleteUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserResponse$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteUserResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteUserResponse
 */
export const DeleteUserResponse = new DeleteUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResendUserInviteRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ResendUserInviteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ResendUserInviteRequest
 */
export const ResendUserInviteRequest = new ResendUserInviteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResendUserInviteResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ResendUserInviteResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ResendUserInviteResponse
 */
export const ResendUserInviteResponse = new ResendUserInviteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReactivateUserRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ReactivateUserRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ReactivateUserRequest
 */
export const ReactivateUserRequest = new ReactivateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReactivateUserResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ReactivateUserResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ReactivateUserResponse
 */
export const ReactivateUserResponse = new ReactivateUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUserTenantsRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ListUserTenantsRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["users.v1.UserTenantStatus", UserTenantStatus, "USER_TENANT_STATUS_"] },
            { no: 4, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.tenantId = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* users.v1.UserTenantStatus status */ 3:
                    message.status = reader.int32();
                    break;
                case /* common.v1.PaginationRequest pagination */ 4:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* users.v1.UserTenantStatus status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        /* common.v1.PaginationRequest pagination = 4; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListUserTenantsRequest
 */
export const ListUserTenantsRequest = new ListUserTenantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUserTenantsResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ListUserTenantsResponse", [
            { no: 1, name: "user_tenants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserTenant },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userTenants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.UserTenant user_tenants */ 1:
                    message.userTenants.push(UserTenant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.UserTenant user_tenants = 1; */
        for (let i = 0; i < message.userTenants.length; i++)
            UserTenant.internalBinaryWrite(message.userTenants[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListUserTenantsResponse
 */
export const ListUserTenantsResponse = new ListUserTenantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.CreateUserTenantRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["users.v1.UserTenantStatus", UserTenantStatus, "USER_TENANT_STATUS_"] },
            { no: 4, name: "primary_tenant", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.tenantId = "";
        message.status = 0;
        message.primaryTenant = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* users.v1.UserTenantStatus status */ 3:
                    message.status = reader.int32();
                    break;
                case /* bool primary_tenant */ 4:
                    message.primaryTenant = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* users.v1.UserTenantStatus status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        /* bool primary_tenant = 4; */
        if (message.primaryTenant !== false)
            writer.tag(4, WireType.Varint).bool(message.primaryTenant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateUserTenantRequest
 */
export const CreateUserTenantRequest = new CreateUserTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.CreateUserTenantResponse", [
            { no: 1, name: "user_tenant", kind: "message", T: () => UserTenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.UserTenant user_tenant */ 1:
                    message.userTenant = UserTenant.internalBinaryRead(reader, reader.uint32(), options, message.userTenant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.UserTenant user_tenant = 1; */
        if (message.userTenant)
            UserTenant.internalBinaryWrite(message.userTenant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateUserTenantResponse
 */
export const CreateUserTenantResponse = new CreateUserTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateUserTenantRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["users.v1.UserTenantStatus", UserTenantStatus, "USER_TENANT_STATUS_"] },
            { no: 4, name: "primary_tenant", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.tenantId = "";
        message.status = 0;
        message.primaryTenant = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                case /* users.v1.UserTenantStatus status */ 3:
                    message.status = reader.int32();
                    break;
                case /* bool primary_tenant */ 4:
                    message.primaryTenant = reader.bool();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 5:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        /* users.v1.UserTenantStatus status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        /* bool primary_tenant = 4; */
        if (message.primaryTenant !== false)
            writer.tag(4, WireType.Varint).bool(message.primaryTenant);
        /* google.protobuf.FieldMask update_mask = 5; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateUserTenantRequest
 */
export const UpdateUserTenantRequest = new UpdateUserTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateUserTenantResponse", [
            { no: 1, name: "user_tenant", kind: "message", T: () => UserTenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.UserTenant user_tenant */ 1:
                    message.userTenant = UserTenant.internalBinaryRead(reader, reader.uint32(), options, message.userTenant);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.UserTenant user_tenant = 1; */
        if (message.userTenant)
            UserTenant.internalBinaryWrite(message.userTenant, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateUserTenantResponse
 */
export const UpdateUserTenantResponse = new UpdateUserTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserTenantRequest$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteUserTenantRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string tenant_id */ 2:
                    message.tenantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string tenant_id = 2; */
        if (message.tenantId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteUserTenantRequest
 */
export const DeleteUserTenantRequest = new DeleteUserTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserTenantResponse$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteUserTenantResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteUserTenantResponse
 */
export const DeleteUserTenantResponse = new DeleteUserTenantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ListCustomersRequest", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tenantId = "";
        message.externalRef = "";
        message.parentCustomerId = "";
        message.includeDeleted = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string external_ref */ 2:
                    message.externalRef = reader.string();
                    break;
                case /* string parent_customer_id */ 3:
                    message.parentCustomerId = reader.string();
                    break;
                case /* bool include_deleted */ 4:
                    message.includeDeleted = reader.bool();
                    break;
                case /* common.v1.PaginationRequest pagination */ 5:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string external_ref = 2; */
        if (message.externalRef !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.externalRef);
        /* string parent_customer_id = 3; */
        if (message.parentCustomerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.parentCustomerId);
        /* bool include_deleted = 4; */
        if (message.includeDeleted !== false)
            writer.tag(4, WireType.Varint).bool(message.includeDeleted);
        /* common.v1.PaginationRequest pagination = 5; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListCustomersRequest
 */
export const ListCustomersRequest = new ListCustomersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ListCustomersResponse", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Customer },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.Customer customers */ 1:
                    message.customers.push(Customer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.Customer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            Customer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListCustomersResponse
 */
export const ListCustomersResponse = new ListCustomersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.CreateCustomerRequest", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "parent_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "fleet_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tenantId = "";
        message.name = "";
        message.externalRef = "";
        message.parentCustomerId = "";
        message.address = "";
        message.phone = "";
        message.siteId = "";
        message.fleetId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string external_ref */ 3:
                    message.externalRef = reader.string();
                    break;
                case /* string parent_customer_id */ 4:
                    message.parentCustomerId = reader.string();
                    break;
                case /* string address */ 5:
                    message.address = reader.string();
                    break;
                case /* string phone */ 6:
                    message.phone = reader.string();
                    break;
                case /* string site_id */ 7:
                    message.siteId = reader.string();
                    break;
                case /* string fleet_id */ 8:
                    message.fleetId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string external_ref = 3; */
        if (message.externalRef !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalRef);
        /* string parent_customer_id = 4; */
        if (message.parentCustomerId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.parentCustomerId);
        /* string address = 5; */
        if (message.address !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.address);
        /* string phone = 6; */
        if (message.phone !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.phone);
        /* string site_id = 7; */
        if (message.siteId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.siteId);
        /* string fleet_id = 8; */
        if (message.fleetId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.fleetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateCustomerRequest
 */
export const CreateCustomerRequest = new CreateCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.CreateCustomerResponse", [
            { no: 1, name: "customer", kind: "message", T: () => Customer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateCustomerResponse
 */
export const CreateCustomerResponse = new CreateCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetCustomerRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetCustomerRequest
 */
export const GetCustomerRequest = new GetCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetCustomerResponse", [
            { no: 1, name: "customer", kind: "message", T: () => Customer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetCustomerResponse
 */
export const GetCustomerResponse = new GetCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateCustomerRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "parent_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 8, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "fleet_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.externalRef = "";
        message.parentCustomerId = "";
        message.address = "";
        message.phone = "";
        message.siteId = "";
        message.fleetId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string external_ref */ 3:
                    message.externalRef = reader.string();
                    break;
                case /* string parent_customer_id */ 4:
                    message.parentCustomerId = reader.string();
                    break;
                case /* string address */ 5:
                    message.address = reader.string();
                    break;
                case /* string phone */ 6:
                    message.phone = reader.string();
                    break;
                case /* google.protobuf.FieldMask update_mask */ 7:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* string site_id */ 8:
                    message.siteId = reader.string();
                    break;
                case /* string fleet_id */ 9:
                    message.fleetId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string external_ref = 3; */
        if (message.externalRef !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalRef);
        /* string parent_customer_id = 4; */
        if (message.parentCustomerId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.parentCustomerId);
        /* string address = 5; */
        if (message.address !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.address);
        /* string phone = 6; */
        if (message.phone !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.phone);
        /* google.protobuf.FieldMask update_mask = 7; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string site_id = 8; */
        if (message.siteId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.siteId);
        /* string fleet_id = 9; */
        if (message.fleetId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.fleetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateCustomerRequest
 */
export const UpdateCustomerRequest = new UpdateCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateCustomerResponse", [
            { no: 1, name: "customer", kind: "message", T: () => Customer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateCustomerResponse
 */
export const UpdateCustomerResponse = new UpdateCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteCustomerRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteCustomerRequest
 */
export const DeleteCustomerRequest = new DeleteCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteCustomerResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "was_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        message.wasDeleted = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* bool was_deleted */ 2:
                    message.wasDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* bool was_deleted = 2; */
        if (message.wasDeleted !== false)
            writer.tag(2, WireType.Varint).bool(message.wasDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteCustomerResponse
 */
export const DeleteCustomerResponse = new DeleteCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ActivateCustomerRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ActivateCustomerRequest
 */
export const ActivateCustomerRequest = new ActivateCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ActivateCustomerResponse", [
            { no: 1, name: "customer", kind: "message", T: () => Customer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.Customer customer */ 1:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.Customer customer = 1; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ActivateCustomerResponse
 */
export const ActivateCustomerResponse = new ActivateCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUserCustomersRequest$Type extends MessageType {
    constructor() {
        super("users.v1.ListUserCustomersRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.customerId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListUserCustomersRequest
 */
export const ListUserCustomersRequest = new ListUserCustomersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUserCustomersResponse$Type extends MessageType {
    constructor() {
        super("users.v1.ListUserCustomersResponse", [
            { no: 1, name: "memberships", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserCustomer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.memberships = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.UserCustomer memberships */ 1:
                    message.memberships.push(UserCustomer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.UserCustomer memberships = 1; */
        for (let i = 0; i < message.memberships.length; i++)
            UserCustomer.internalBinaryWrite(message.memberships[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.ListUserCustomersResponse
 */
export const ListUserCustomersResponse = new ListUserCustomersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.CreateUserCustomerRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group", kind: "enum", T: () => ["users.v1.CustomerGroup", CustomerGroup, "CUSTOMER_GROUP_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.customerId = "";
        message.group = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                case /* users.v1.CustomerGroup group */ 3:
                    message.group = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        /* users.v1.CustomerGroup group = 3; */
        if (message.group !== 0)
            writer.tag(3, WireType.Varint).int32(message.group);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateUserCustomerRequest
 */
export const CreateUserCustomerRequest = new CreateUserCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.CreateUserCustomerResponse", [
            { no: 1, name: "membership", kind: "message", T: () => UserCustomer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.UserCustomer membership */ 1:
                    message.membership = UserCustomer.internalBinaryRead(reader, reader.uint32(), options, message.membership);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.UserCustomer membership = 1; */
        if (message.membership)
            UserCustomer.internalBinaryWrite(message.membership, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.CreateUserCustomerResponse
 */
export const CreateUserCustomerResponse = new CreateUserCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateUserCustomerRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "group", kind: "enum", T: () => ["users.v1.CustomerGroup", CustomerGroup, "CUSTOMER_GROUP_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.customerId = "";
        message.group = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                case /* users.v1.CustomerGroup group */ 3:
                    message.group = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        /* users.v1.CustomerGroup group = 3; */
        if (message.group !== 0)
            writer.tag(3, WireType.Varint).int32(message.group);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateUserCustomerRequest
 */
export const UpdateUserCustomerRequest = new UpdateUserCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.UpdateUserCustomerResponse", [
            { no: 1, name: "membership", kind: "message", T: () => UserCustomer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.UserCustomer membership */ 1:
                    message.membership = UserCustomer.internalBinaryRead(reader, reader.uint32(), options, message.membership);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.UserCustomer membership = 1; */
        if (message.membership)
            UserCustomer.internalBinaryWrite(message.membership, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.UpdateUserCustomerResponse
 */
export const UpdateUserCustomerResponse = new UpdateUserCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserCustomerRequest$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteUserCustomerRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = "";
        message.customerId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteUserCustomerRequest
 */
export const DeleteUserCustomerRequest = new DeleteUserCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserCustomerResponse$Type extends MessageType {
    constructor() {
        super("users.v1.DeleteUserCustomerResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.DeleteUserCustomerResponse
 */
export const DeleteUserCustomerResponse = new DeleteUserCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginRequest$Type extends MessageType {
    constructor() {
        super("users.v1.LoginRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.LoginRequest
 */
export const LoginRequest = new LoginRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginResponse$Type extends MessageType {
    constructor() {
        super("users.v1.LoginResponse", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expires_in", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.accessToken = "";
        message.refreshToken = "";
        message.idToken = "";
        message.expiresIn = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* string refresh_token */ 2:
                    message.refreshToken = reader.string();
                    break;
                case /* string id_token */ 3:
                    message.idToken = reader.string();
                    break;
                case /* int64 expires_in */ 4:
                    message.expiresIn = reader.int64().toBigInt();
                    break;
                case /* users.v1.User user */ 5:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* string refresh_token = 2; */
        if (message.refreshToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.refreshToken);
        /* string id_token = 3; */
        if (message.idToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.idToken);
        /* int64 expires_in = 4; */
        if (message.expiresIn !== 0n)
            writer.tag(4, WireType.Varint).int64(message.expiresIn);
        /* users.v1.User user = 5; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.LoginResponse
 */
export const LoginResponse = new LoginResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LogoutRequest$Type extends MessageType {
    constructor() {
        super("users.v1.LogoutRequest", [
            { no: 1, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.refreshToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string refresh_token */ 1:
                    message.refreshToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string refresh_token = 1; */
        if (message.refreshToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.refreshToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.LogoutRequest
 */
export const LogoutRequest = new LogoutRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LogoutResponse$Type extends MessageType {
    constructor() {
        super("users.v1.LogoutResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.LogoutResponse
 */
export const LogoutResponse = new LogoutResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshTokenRequest$Type extends MessageType {
    constructor() {
        super("users.v1.RefreshTokenRequest", [
            { no: 1, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.refreshToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string refresh_token */ 1:
                    message.refreshToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string refresh_token = 1; */
        if (message.refreshToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.refreshToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.RefreshTokenRequest
 */
export const RefreshTokenRequest = new RefreshTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshTokenResponse$Type extends MessageType {
    constructor() {
        super("users.v1.RefreshTokenResponse", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expires_in", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.accessToken = "";
        message.idToken = "";
        message.expiresIn = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* string id_token */ 2:
                    message.idToken = reader.string();
                    break;
                case /* int64 expires_in */ 3:
                    message.expiresIn = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* string id_token = 2; */
        if (message.idToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.idToken);
        /* int64 expires_in = 3; */
        if (message.expiresIn !== 0n)
            writer.tag(3, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.RefreshTokenResponse
 */
export const RefreshTokenResponse = new RefreshTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentUserRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetCurrentUserRequest", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetCurrentUserRequest
 */
export const GetCurrentUserRequest = new GetCurrentUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentUserResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetCurrentUserResponse", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "user_tenants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserTenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userTenants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* users.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated users.v1.UserTenant user_tenants */ 2:
                    message.userTenants.push(UserTenant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* users.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated users.v1.UserTenant user_tenants = 2; */
        for (let i = 0; i < message.userTenants.length; i++)
            UserTenant.internalBinaryWrite(message.userTenants[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetCurrentUserResponse
 */
export const GetCurrentUserResponse = new GetCurrentUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessibleCustomersRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetAccessibleCustomersRequest", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetAccessibleCustomersRequest
 */
export const GetAccessibleCustomersRequest = new GetAccessibleCustomersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessibleCustomersResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetAccessibleCustomersResponse", [
            { no: 1, name: "accessible_customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessibleCustomer }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.accessibleCustomers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.AccessibleCustomer accessible_customers */ 1:
                    message.accessibleCustomers.push(AccessibleCustomer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.AccessibleCustomer accessible_customers = 1; */
        for (let i = 0; i < message.accessibleCustomers.length; i++)
            AccessibleCustomer.internalBinaryWrite(message.accessibleCustomers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetAccessibleCustomersResponse
 */
export const GetAccessibleCustomersResponse = new GetAccessibleCustomersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserTenantsRequest$Type extends MessageType {
    constructor() {
        super("users.v1.GetUserTenantsRequest", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetUserTenantsRequest
 */
export const GetUserTenantsRequest = new GetUserTenantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserTenantsResponse$Type extends MessageType {
    constructor() {
        super("users.v1.GetUserTenantsResponse", [
            { no: 1, name: "user_tenants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserTenant }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userTenants = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated users.v1.UserTenant user_tenants */ 1:
                    message.userTenants.push(UserTenant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated users.v1.UserTenant user_tenants = 1; */
        for (let i = 0; i < message.userTenants.length; i++)
            UserTenant.internalBinaryWrite(message.userTenants[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message users.v1.GetUserTenantsResponse
 */
export const GetUserTenantsResponse = new GetUserTenantsResponse$Type();
/**
 * @generated ServiceType for protobuf service users.v1.TenantService
 */
export const TenantService = new ServiceType("users.v1.TenantService", [
    { name: "ListTenants", options: { "google.api.http": { get: "/v1/tenants" } }, I: ListTenantsRequest, O: ListTenantsResponse },
    { name: "CreateTenant", options: { "google.api.http": { post: "/v1/tenants", body: "*" } }, I: CreateTenantRequest, O: CreateTenantResponse },
    { name: "GetTenant", options: { "google.api.http": { get: "/v1/tenants/{id}" } }, I: GetTenantRequest, O: GetTenantResponse },
    { name: "UpdateTenant", options: { "google.api.http": { put: "/v1/tenants/{id}", body: "*" } }, I: UpdateTenantRequest, O: UpdateTenantResponse },
    { name: "DeleteTenant", options: { "google.api.http": { delete: "/v1/tenants/{id}" } }, I: DeleteTenantRequest, O: DeleteTenantResponse },
    { name: "BumpAuthzVersion", options: { "google.api.http": { post: "/v1/tenants/{tenant_id}/bump-authz-version" } }, I: BumpAuthzVersionRequest, O: BumpAuthzVersionResponse }
]);
/**
 * @generated ServiceType for protobuf service users.v1.UserService
 */
export const UserService = new ServiceType("users.v1.UserService", [
    { name: "ListUsers", options: { "google.api.http": { get: "/v1/users" } }, I: ListUsersRequest, O: ListUsersResponse },
    { name: "CreateUser", options: { "google.api.http": { post: "/v1/users", body: "*" } }, I: CreateUserRequest, O: CreateUserResponse },
    { name: "GetUser", options: { "google.api.http": { get: "/v1/users/{id}" } }, I: GetUserRequest, O: GetUserResponse },
    { name: "GetUserByEmail", options: { "google.api.http": { get: "/v1/users/by-email/{email}" } }, I: GetUserByEmailRequest, O: GetUserByEmailResponse },
    { name: "UpdateUser", options: { "google.api.http": { put: "/v1/users/{id}", body: "*" } }, I: UpdateUserRequest, O: UpdateUserResponse },
    { name: "DeleteUser", options: { "google.api.http": { delete: "/v1/users/{id}" } }, I: DeleteUserRequest, O: DeleteUserResponse },
    { name: "ResendUserInvite", options: {}, I: ResendUserInviteRequest, O: ResendUserInviteResponse },
    { name: "ReactivateUser", options: {}, I: ReactivateUserRequest, O: ReactivateUserResponse }
]);
/**
 * @generated ServiceType for protobuf service users.v1.UserTenantService
 */
export const UserTenantService = new ServiceType("users.v1.UserTenantService", [
    { name: "ListUserTenants", options: { "google.api.http": { get: "/v1/user-tenants" } }, I: ListUserTenantsRequest, O: ListUserTenantsResponse },
    { name: "CreateUserTenant", options: { "google.api.http": { post: "/v1/user-tenants", body: "*" } }, I: CreateUserTenantRequest, O: CreateUserTenantResponse },
    { name: "UpdateUserTenant", options: { "google.api.http": { put: "/v1/user-tenants/{user_id}/{tenant_id}", body: "*" } }, I: UpdateUserTenantRequest, O: UpdateUserTenantResponse },
    { name: "DeleteUserTenant", options: { "google.api.http": { delete: "/v1/user-tenants/{user_id}/{tenant_id}" } }, I: DeleteUserTenantRequest, O: DeleteUserTenantResponse }
]);
/**
 * @generated ServiceType for protobuf service users.v1.CustomerService
 */
export const CustomerService = new ServiceType("users.v1.CustomerService", [
    { name: "ListCustomers", options: { "google.api.http": { get: "/v1/customers" } }, I: ListCustomersRequest, O: ListCustomersResponse },
    { name: "CreateCustomer", options: { "google.api.http": { post: "/v1/customers", body: "*" } }, I: CreateCustomerRequest, O: CreateCustomerResponse },
    { name: "GetCustomer", options: { "google.api.http": { get: "/v1/customers/{id}" } }, I: GetCustomerRequest, O: GetCustomerResponse },
    { name: "UpdateCustomer", options: { "google.api.http": { put: "/v1/customers/{id}", body: "*" } }, I: UpdateCustomerRequest, O: UpdateCustomerResponse },
    { name: "DeleteCustomer", options: { "google.api.http": { delete: "/v1/customers/{id}" } }, I: DeleteCustomerRequest, O: DeleteCustomerResponse },
    { name: "ActivateCustomer", options: { "google.api.http": { post: "/v1/customers/{id}/activate", body: "*" } }, I: ActivateCustomerRequest, O: ActivateCustomerResponse }
]);
/**
 * @generated ServiceType for protobuf service users.v1.UserCustomerService
 */
export const UserCustomerService = new ServiceType("users.v1.UserCustomerService", [
    { name: "ListUserCustomers", options: { "google.api.http": { get: "/v1/user-customers" } }, I: ListUserCustomersRequest, O: ListUserCustomersResponse },
    { name: "CreateUserCustomer", options: { "google.api.http": { post: "/v1/user-customers", body: "*" } }, I: CreateUserCustomerRequest, O: CreateUserCustomerResponse },
    { name: "UpdateUserCustomer", options: { "google.api.http": { put: "/v1/user-customers/{user_id}/{customer_id}", body: "*" } }, I: UpdateUserCustomerRequest, O: UpdateUserCustomerResponse },
    { name: "DeleteUserCustomer", options: { "google.api.http": { delete: "/v1/user-customers/{user_id}/{customer_id}" } }, I: DeleteUserCustomerRequest, O: DeleteUserCustomerResponse }
]);
/**
 * @generated ServiceType for protobuf service users.v1.AuthService
 */
export const AuthService = new ServiceType("users.v1.AuthService", [
    { name: "Login", options: {}, I: LoginRequest, O: LoginResponse },
    { name: "Logout", options: {}, I: LogoutRequest, O: LogoutResponse },
    { name: "RefreshToken", options: {}, I: RefreshTokenRequest, O: RefreshTokenResponse },
    { name: "GetCurrentUser", options: {}, I: GetCurrentUserRequest, O: GetCurrentUserResponse },
    { name: "GetAccessibleCustomers", options: {}, I: GetAccessibleCustomersRequest, O: GetAccessibleCustomersResponse },
    { name: "GetUserTenants", options: {}, I: GetUserTenantsRequest, O: GetUserTenantsResponse }
]);
//# sourceMappingURL=service.js.map